import { animate, style, transition, trigger } from '@angular/animations';

export const MOVIE_TEMPLATE_ANIMATIONS = [
  trigger('showUp', [
    transition(':enter', [
      style({
        opacity: '0',
        'z-index': '-1'
      }),
      animate(
        '.5s ease-out',
        style({
          opacity: '1',
          'z-index': '-1'
        })
      )
    ])
  ]),

  trigger('fadeIn', [
    transition(':enter', [
      style({
        opacity: '0',
        marginTop: '30px'
      }),
      animate(
        '.5s ease-out',
        style({
          opacity: '1',
          marginTop: '0px'
        })
      )
    ])
  ])
];
